import React, { useEffect, useMemo, useState } from 'react';
import { Col, Container, Input, Row, Table } from 'reactstrap';
import { CommonButton } from '../../../Components/CommonComponents';
import {
  AcceptOrderConfirmModal,
  ConfirmSummaryModal,
  OrderSummaryModal,
  PartiallyAcceptOrderConfirmModal,
  RejectOrderConfirmModal,
} from '../../../Components/CustomModal';
import CustomSpinner from '../../../Components/CustomSpinner/CustomSpinner';
import { DashBoardTitle } from '../../../Components/Title';

import excelImage from '../../../images/tableExcel.png';

import './index.css';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import {
  CNFBookMultipleOrder,
  CNFBookOrder,
  exportCNFOpenOrders,
  getCNFOpenOrders,
  getCNFTerritoryManagers,
} from '../../../constants/apiCalls';
import moment from 'moment';
import _ from 'lodash';
import AcceptMultipleOrderConfirmModal from '../../../Components/CustomModal/AcceptMultipleOrderConfirmModal/AcceptMultipleOrderConfirmModal';
import RejectMultipleOrderConfirmModal from '../../../Components/CustomModal/RejectMultipleOrderConfirmModal/RejectMultipleOrderConfirmModal';
import { CNFAddInvoice } from '../../../constants/apiCalls';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';

function OpenOrders() {
  const [isLoading, setIsLoading] = useState(false);
  const [orderSummaryModal, setOrderSummaryModal] = useState(false);
  const [orderSummaryData, setOrderSummaryData] = useState(null);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const [
    multipleAcceptOrderConfirmModal,
    setMultipleAcceptOrderConfirmModal,
  ] = useState(false);
  const [
    multipleRejectOrderConfirmModal,
    setMultipleRejectOrderConfirmModal,
  ] = useState(false);

  const [cancelOrderConfirmModal, setCancelOrderConfirmModal] = useState(false);
  const [cancelOrderData, setCancelOrderData] = useState(null);

  const [acceptOrderConfirmModal, setAcceptOrderConfirmModal] = useState(false);
  const [
    acceptOrderConfirmProductId,
    setAcceptOrderConfirmProductId,
  ] = useState('');

  const [territoryList, setTerritoryList] = useState([]);
  const [territoryManagerList, setTerritoryManagerList] = useState([]);

  const [territoryId, setTerritoryId] = useState('');
  const [tmId, setTmId] = useState('');

  const [confirmSummaryModal, setConfirmSummaryModal] = useState(false);
  // const [confirmSummaryData, setConfirmSummaryData] = useState(null);

  const filteredTerritory = useMemo(() => {
    if (tmId === 'all') {
      return territoryList;
    }

    if (tmId) {
      const finalList = territoryList.filter((t) => {
        const list = territoryManagerList
          .filter((tl) => tl.user_id.toString() === tmId)
          .map((o) => o.territory_id);
        return list.includes(t.territory_id);
      });
      return finalList;
    }
    return territoryList;
  }, [tmId, territoryList, territoryManagerList]);

  // Date Filter
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [rejectOrderConfirmModal, setRejectOrderConfirmModal] = useState(false);
  const [
    rejectOrderConfirmProductId,
    setRejectOrderConfirmProductId,
  ] = useState('');

  const [
    partiallyAcceptOrderConfirmModal,
    setPartiallyAcceptOrderConfirmModal,
  ] = useState(false);
  const [
    partiallyAcceptOrderConfirmProductId,
    setPartiallyAcceptOrderConfirmProductId,
  ] = useState('');

  const [data, setData] = useState([]);
  const [isBookOrder, setBookOrder] = useState(false);
  const [bookOrderData, setBookOrderData] = useState([]);
  const [bookOrderId, setBookOrderId] = useState('');

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    setIsLoading(true);
    getCNFTerritoryManagers((res) => {
      const { data, success, error } = res;
      if (success === true) {
        setTerritoryList(data.territory);
        setTerritoryManagerList(data.territory_manager);

        setIsLoading(false);
      } else if (success === false || success === 'undefined') {
        setIsLoading(false);
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
      }
      setIsLoading(false);
    });
  }, []);

  const fetchData = () => {
    setIsLoading(true);

    const payload = { page, pagesize: pageSize };

    if (searchText) {
      payload.q = searchText.trim();
    }
    if (territoryId && territoryId !== 'all') {
      payload.territory_id = territoryId;
    }
    if (tmId && tmId !== 'all') {
      payload.user_id = tmId;
    }
    if (startDate) {
      payload.start_date = moment(startDate).format('MM-DD-YYYY');
    }
    if (endDate) {
      payload.end_date = moment(endDate).format('MM-DD-YYYY');
    }

    getCNFOpenOrders((res) => {
      const { data, success, error } = res;

      if (success) {
        setIsLoading(false);
        setData(data);
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsLoading(false);
      }
    }, payload);
  };

  const debouncedSearch = _.debounce(() => fetchData(), 300);

  useEffect(() => {
    if (!territoryId) return;
    fetchData();
  }, [territoryId]);

  useEffect(() => {
    if (!tmId) return;
    fetchData();
  }, [tmId]);

  useEffect(() => {
    fetchData();
  }, [startDate]);

  useEffect(() => {
    fetchData();
  }, [endDate]);

  useEffect(() => {
    if (!searchText) return;
    debouncedSearch();
  }, [searchText]);

  useEffect(() => {
    fetchData();
  }, [page, pageSize]);

  const acceptMultiple = () => {
    setIsLoading(true);
    CNFBookMultipleOrder(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          // Update Local State so that UI can update optimistically
          setBookOrderData((prev) =>
            prev.map((d) => {
              if (selectedProducts.includes(d.order_product_id)) {
                return { ...d, action: 'accept', action_reason: 'Accepted' };
              }
              return d;
            }),
          );

          setSelectedProducts([]);
          setMultipleAcceptOrderConfirmModal(false);
        } else if (success === false || success === 'undefined') {
          setMultipleAcceptOrderConfirmModal(false);
          setIsLoading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        order_product_ids: selectedProducts,
        action: 'accept',
        action_reason: 'Accepted',
      },
    ).finally(() => {
      setIsLoading(false);
    });
  };

  const rejectMultiple = () => {
    setIsLoading(true);
    CNFBookMultipleOrder(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          // Update Local State so that UI can update optimistically
          setBookOrderData((prev) =>
            prev.map((d) => {
              if (selectedProducts.includes(d.order_product_id)) {
                return { ...d, action: 'reject', action_reason: 'Rejected' };
              }
              return d;
            }),
          );

          setSelectedProducts([]);
          setMultipleRejectOrderConfirmModal(false);
        } else if (success === false || success === 'undefined') {
          setMultipleRejectOrderConfirmModal(false);
          setIsLoading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        order_product_ids: selectedProducts,
        action: 'reject',
        action_reason: 'Rejected',
      },
    ).finally(() => {
      setIsLoading(false);
    });
  };

  const partiallyAccept = (noOfPackages, reason) => {
    setIsLoading(true);
    CNFBookOrder(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          // Update Local State so that UI can update optimistically
          setBookOrderData((prev) =>
            prev.map((d) => {
              if (d.order_product_id === partiallyAcceptOrderConfirmProductId) {
                return {
                  ...d,
                  action: 'Partially Accepted',
                  no_of_packages: noOfPackages,
                  action_reason: reason,
                };
              }
              return d;
            }),
          );

          setPartiallyAcceptOrderConfirmModal(false);
          setPartiallyAcceptOrderConfirmProductId('');
        } else if (success === false || success === 'undefined') {
          setPartiallyAcceptOrderConfirmModal(false);
          setPartiallyAcceptOrderConfirmProductId('');
          setIsLoading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        order_product_id: partiallyAcceptOrderConfirmProductId,
        action: 'partially_accept',
        action_reason: reason,
        no_of_packages: noOfPackages,
      },
    ).finally(() => {
      setIsLoading(false);
    });
  };

  const acceptOrder = () => {
    setIsLoading(true);
    CNFBookOrder(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          // Update Local State so that UI can update optimistically
          setBookOrderData((prev) =>
            prev.map((d) => {
              if (d.order_product_id === acceptOrderConfirmProductId) {
                return { ...d, action: 'Accepted' };
              }
              return d;
            }),
          );

          setAcceptOrderConfirmModal(false);
          setAcceptOrderConfirmProductId('');
        } else if (success === false || success === 'undefined') {
          setAcceptOrderConfirmModal(false);
          setAcceptOrderConfirmProductId('');
          setIsLoading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        order_product_id: acceptOrderConfirmProductId,
        action: 'accept',
        cnf_remark: '',
        action_reason: '',
      },
    ).finally(() => {
      setIsLoading(false);
    });
  };

  const cancelOrder = (reason) => {
    setIsLoading(true);
    CNFBookMultipleOrder(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          fetchData();
          setCancelOrderData(null);
          setCancelOrderConfirmModal(false);
        } else if (success === false || success === 'undefined') {
          setIsLoading(false);
          setCancelOrderData(null);
          setCancelOrderConfirmModal(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        order_product_ids: cancelOrderData.order_product_data.map(
          (d) => d.order_product_id,
        ),
        action: 'reject',
        action_reason: reason,
        all_order_products_rejected: true,
        order_id: cancelOrderData.order_number,
      },
    );
  };

  const rejectOrder = (reason) => {
    setIsLoading(true);
    CNFBookOrder(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          // Update Local State so that UI can update optimistically
          setBookOrderData((prev) =>
            prev.map((d) => {
              if (d.order_product_id === rejectOrderConfirmProductId) {
                return {
                  ...d,
                  action: 'Rejected',
                  action_reason: reason || '',
                  no_of_packages: '0',
                };
              }
              return d;
            }),
          );

          setRejectOrderConfirmModal(false);
          setRejectOrderConfirmProductId('');
        } else if (success === false || success === 'undefined') {
          setRejectOrderConfirmModal(false);
          setRejectOrderConfirmProductId('');
          setIsLoading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },
      {
        order_product_id: rejectOrderConfirmProductId,
        action: 'reject',
        cnf_remark: reason || '',
        action_reason: reason || '',
      },
    ).finally(() => {
      setIsLoading(false);
    });
  };

  const exportImage = () => {
    setIsLoading(true);

    const payload = { page, pagesize: pageSize };

    if (searchText) {
      payload.q = searchText.trim();
    }
    if (territoryId && territoryId !== 'all') {
      payload.territory_id = territoryId;
    }
    if (tmId && tmId !== 'all') {
      payload.user_id = tmId;
    }
    if (startDate) {
      payload.start_date = moment(startDate).format('MM-DD-YYYY');
    }
    if (endDate) {
      payload.end_date = moment(endDate).format('MM-DD-YYYY');
    }

    exportCNFOpenOrders((res) => {
      const { data, success, error } = res;

      if (success) {
        setIsLoading(false);
        window.open(data.file, '_blank');
      } else if (success === false || success === 'undefined') {
        ModalService.openAlert(
          '',
          handleErrorMessage(error[0].message),
          'error',
        );
        setIsLoading(false);
      }
    }, payload);
  };

  const addInvoiceData = (data) => {
    setIsLoading(true);
    CNFAddInvoice(
      (res) => {
        const { success, error } = res;

        if (success) {
          setIsLoading(false);

          setBookOrder(false);
          setBookOrderData([]);
          setBookOrderId('');
          setConfirmSummaryModal(false);
          // setConfirmSummaryData(null);
          fetchData();
        } else if (success === false || success === 'undefined') {
          setIsLoading(false);
          ModalService.openAlert(
            '',
            handleErrorMessage(error[0].message),
            'error',
          );
        }
      },

      {
        order_id: bookOrderId,
        invoice_date: moment(data.invoice_data).format('MM-DD-YYYY'),
        invoice_no: data.invoice_no,
        transporter_name: data.transporter_name || '',
        lr_dispatch_details: data.lr_dispatch_details || '',
      },
    ).finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id="cnf-open-orders">
              {isLoading && <CustomSpinner />}
              <Container fluid>
                <Row>
                  <Col xs={12}>
                    <div className="pageheader">
                      <DashBoardTitle dashBorardName="Open Orders" />
                      {isBookOrder && (
                        <CommonButton
                          name={'Back'}
                          btnClass={'btnTernary mt-0 mb-0 mr-0'}
                          type="button"
                          onClick={() => {
                            setBookOrder(false);
                            setSelectedProducts([]);
                            setBookOrderData([]);
                            setBookOrderId('');
                          }}
                        />
                      )}
                    </div>
                  </Col>
                </Row>
                {isBookOrder && bookOrderData ? (
                  <div className="tableArea">
                    <Table bordered responsive>
                      <thead>
                        <tr>
                          <th>
                            {!!bookOrderData.filter((d) => d.action === 'Pending')
                              .length && (
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedProducts.length === bookOrderData.length
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedProducts(
                                        bookOrderData.map((d) =>
                                          d.action !== 'Pending'
                                            ? null
                                            : d.order_product_id,
                                        ),
                                      );
                                    } else {
                                      setSelectedProducts([]);
                                    }
                                  }}
                                />
                              )}
                          </th>
                          <th>Sr No.</th>
                          <th>Material Details</th>
                          <th>No. of Packages</th>
                          <th>Total Quantity</th>
                          <th>Order Revision Remark</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookOrderData.map((product, i) => {
                          return (
                            <tr>
                              <td>
                                {product.action === 'Pending' && (
                                  <input
                                    type="checkbox"
                                    checked={selectedProducts.includes(
                                      product.order_product_id,
                                    )}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedProducts([
                                          ...selectedProducts,
                                          product.order_product_id,
                                        ]);
                                      } else {
                                        setSelectedProducts((prev) =>
                                          prev.filter((d) => {
                                            return d !== product.order_product_id;
                                          }),
                                        );
                                      }
                                    }}
                                  />
                                )}
                              </td>
                              <td>{i + 1}</td>
                              <td>{product.name || '-'}</td>
                              <td>{product.qty || '-'}</td>
                              <td>{product.total_quantity || '-'}</td>
                              <td>{product.revision_order_remark || 'N/A'}</td>
                              <td>
                                {product.action === 'Accepted' ? (
                                  <div className="textButton_green">
                                    <strong>Accepted</strong>
                                  </div>
                                ) : product.action === 'Rejected' ? (
                                  <div className="textButton_red">
                                    <strong>Rejected</strong>
                                  </div>
                                ) : product.action === 'Partially Accepted' ? (
                                  <div className="textButton_blue">
                                    <strong>Partially Accepted</strong>
                                  </div>
                                ) : (
                                  <div className="tableActions">
                                    <button
                                      className="textButton textButton_green"
                                      onClick={() => {
                                        setAcceptOrderConfirmModal(true);
                                        setAcceptOrderConfirmProductId(
                                          product.order_product_id,
                                        );
                                      }}
                                    >
                                      Accept
                                    </button>
                                    <button
                                      className="textButton textButton_blue"
                                      onClick={() => {
                                        setPartiallyAcceptOrderConfirmModal(true);
                                        setPartiallyAcceptOrderConfirmProductId(
                                          product.order_product_id,
                                        );
                                      }}
                                    >
                                      Partially Accept
                                    </button>
                                    <button
                                      className="textButton textButton_red"
                                      onClick={() => {
                                        setRejectOrderConfirmModal(true);
                                        setRejectOrderConfirmProductId(
                                          product.order_product_id,
                                        );
                                      }}
                                    >
                                      Reject
                                    </button>
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    {bookOrderData.filter((d) => d.action !== 'Pending').length ===
                      bookOrderData.length && (
                        <div className="invoiceBtnCont">
                          <button
                            className="customButton customButton_blue"
                            onClick={() => {
                              const payload = { page, pagesize: pageSize };

                              if (searchText) {
                                payload.q = searchText.trim();
                              }
                              if (territoryId && territoryId !== 'all') {
                                payload.territory_id = territoryId;
                              }
                              if (tmId && tmId !== 'all') {
                                payload.user_id = tmId;
                              }
                              if (startDate) {
                                payload.start_date = moment(startDate).format(
                                  'MM-DD-YYYY',
                                );
                              }
                              if (endDate) {
                                payload.end_date = moment(endDate).format('MM-DD-YYYY');
                              }

                              getCNFOpenOrders((res) => {
                                const { data, success } = res;

                                if (success) {
                                  setIsLoading(false);
                                  setConfirmSummaryModal(true);

                                  setBookOrderData((pre) => {
                                    if (
                                      data.filter(
                                        (f) => f.order_number === bookOrderId,
                                      )[0].order_product_data &&
                                      data.filter(
                                        (f) => f.order_number === bookOrderId,
                                      )[0].order_product_data.length
                                    ) {
                                      return data.filter(
                                        (f) => f.order_number === bookOrderId,
                                      )[0].order_product_data;
                                    }
                                    return pre;
                                  });
                                } else if (success === false || success === 'undefined') {
                                  ModalService.openAlert(
                                    '',
                                    "Couldn't fetch latest data",
                                    'error',
                                  );
                                  setIsLoading(false);
                                }
                              }, payload);
                            }}
                          >
                            Add Invoice Details
                          </button>
                        </div>
                      )}
                    {!!selectedProducts.length && (
                      <div className="invoiceBtnCont">
                        <button
                          className="customButton customButton_outline customButton_blue"
                          onClick={() => setMultipleRejectOrderConfirmModal(true)}
                        >
                          Reject
                        </button>
                        <button
                          className="customButton customButton_blue"
                          onClick={() => setMultipleAcceptOrderConfirmModal(true)}
                        >
                          Accept
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <>
                    <div className="filterArea">
                      <Row>
                        <Col>
                          <div className="searchInput">
                            <Input
                              name="search"
                              autoComplete="off"
                              value={searchText}
                              onChange={(e) => setSearchText(e.target.value)}
                              type="text"
                              placeholder="Search by Code, Name or Mobile"
                              id="search"
                            />
                            <img
                              src={excelImage}
                              onClick={exportImage}
                              style={{ cursor: 'pointer' }}
                              className="excelImg"
                              alt="excel"
                            />
                          </div>
                          <Row className="filterContainer">
                            {/* Territory */}
                            <div className="filterDropdown">
                              <label htmlFor="territoryName">Territory Manager:</label>
                              <br />
                              <select
                                value={tmId}
                                onChange={(e) => setTmId(e.target.value)}
                                name="territoryManager"
                                id="territoryManager"
                              >
                                <option value="all">All</option>
                                {territoryManagerList.length > 0 &&
                                  [
                                    ...new Map(
                                      territoryManagerList.map((item) => [
                                        item['business_name'],
                                        item,
                                      ]),
                                    ).values(),
                                  ].map((elem, index) => {
                                    const {
                                      id = null,
                                      user_id = null,
                                      business_name,
                                    } = elem;
                                    return (
                                      <option value={user_id || id} key={index}>
                                        {business_name}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>
                            <div className="filterDropdown ">
                              <label htmlFor="tmName">Territory:</label>
                              <br />

                              <select
                                name="territory"
                                id="territory"
                                value={territoryId}
                                onChange={(e) => setTerritoryId(e.target.value)}
                              >
                                <option value="all" key="0-random">
                                  All
                                </option>
                                {filteredTerritory.length > 0 &&
                                  filteredTerritory.map((elem, index) => {
                                    const { name, territory_id } = elem;
                                    return (
                                      <option value={territory_id} key={index}>
                                        {name}
                                      </option>
                                    );
                                  })}
                              </select>
                            </div>

                            <div className="filterDate filterInput">
                              <label htmlFor="startDate">From Date:</label>
                              <br />
                              <input
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                                type="date"
                                name="startDate"
                                id="startDate"
                              />
                            </div>
                            <div className="filterDate filterInput">
                              <label htmlFor="endDate">To Date:</label>
                              <br />
                              <input
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                type="date"
                                name="endDate"
                                id="endDate"
                              />
                            </div>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                    <div className="tableArea">
                      <Table bordered responsive>
                        <thead>
                          <tr>
                            <th>Order Date</th>
                            <th>Order Number</th>
                            <th>Dealer Code</th>
                            <th>Dealership Name</th>
                            <th>Mobile No.</th>
                            <th>Territory</th>
                            <th>Order Remark</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((row) => {
                            return (
                              <tr>
                                <td>{moment(row.order_date).format('ll')}</td>
                                <td>
                                  <span
                                    className="orderNumber"
                                    onClick={() => {
                                      setOrderSummaryModal(true);
                                      setOrderSummaryData(row);
                                    }}
                                  >
                                    {row.order_number}
                                  </span>
                                </td>
                                <td>{row.dealer_code}</td>
                                <td>{row.dealership_name}</td>
                                <td>{row.mobile_number || '-'}</td>
                                <td>{row.territory}</td>
                                <td>{row.order_remarks || "N/A"}</td>
                                <td>
                                  <button
                                    className="textButton textButton_green"
                                    onClick={() => {
                                      setBookOrder(true);
                                      setBookOrderData(row.order_product_data || []);
                                      setBookOrderId(row.order_number);
                                    }}
                                  >
                                    Book Order
                                  </button>
                                  <button
                                    onClick={() => {
                                      setCancelOrderConfirmModal(true);
                                      setCancelOrderData(row);
                                    }}
                                    className="textButton textButton_red"
                                  >
                                    Cancel Order
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>
                    <div className="paginationArea">
                      <button
                        className="textButton textButton_blue"
                        onClick={() => {
                          if (page <= 1) {
                            return;
                          }

                          setPage((p) => p - 1);
                        }}
                      >
                        Previous
                      </button>
                      <div className="paginator">
                        <span>Page</span>
                        <input
                          min={1}
                          type="number"
                          defaultValue={1}
                          value={page}
                          onChange={(e) => setPage(e.target.value)}
                        />
                        <span>
                          of <strong>20</strong>
                        </span>
                        <select onChange={(e) => setPageSize(e.target.value)}>
                          <option value={10}>10 Rows</option>
                          <option value={20}>20 Rows</option>
                          <option value={30}>30 Rows</option>
                        </select>
                      </div>
                      <button
                        className="textButton textButton_blue"
                        onClick={() => {
                          setPage((p) => p + 1);
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </>
                )}
              </Container>
              {orderSummaryModal && (
                <OrderSummaryModal
                  orderData={orderSummaryData}
                  isOpen={orderSummaryModal}
                  toggle={() => {
                    setOrderSummaryModal(!orderSummaryModal);
                    if (orderSummaryData !== null) {
                      setOrderSummaryData(null);
                    }
                  }}
                />
              )}
              {confirmSummaryModal && (
                <ConfirmSummaryModal
                  isOpen={confirmSummaryModal}
                  orderData={bookOrderData}
                  orderNumber={bookOrderId}
                  addInvoice={addInvoiceData}
                  toggle={() => {
                    setConfirmSummaryModal(!confirmSummaryModal);
                    // setConfirmSummaryData(null);
                  }}
                />
              )}

              {acceptOrderConfirmModal && (
                <AcceptOrderConfirmModal
                  isOpen={acceptOrderConfirmModal}
                  acceptOrder={acceptOrder}
                  toggle={() => {
                    setAcceptOrderConfirmModal(!acceptOrderConfirmModal);
                    setAcceptOrderConfirmProductId('');
                  }}
                />
              )}

              {cancelOrderConfirmModal && (
                <RejectOrderConfirmModal
                  isOpen={cancelOrderConfirmModal}
                  rejectOrder={cancelOrder}
                  title="Cancel Order"
                  toggle={() => {
                    setCancelOrderConfirmModal(!cancelOrderConfirmModal);
                    setCancelOrderData(null);
                  }}
                />
              )}

              {multipleAcceptOrderConfirmModal && (
                <AcceptMultipleOrderConfirmModal
                  isOpen={multipleAcceptOrderConfirmModal}
                  acceptOrder={acceptMultiple}
                  toggle={() => {
                    setMultipleAcceptOrderConfirmModal(
                      !multipleAcceptOrderConfirmModal,
                    );
                  }}
                />
              )}
              {multipleRejectOrderConfirmModal && (
                <RejectMultipleOrderConfirmModal
                  isOpen={multipleRejectOrderConfirmModal}
                  rejectOrder={rejectMultiple}
                  toggle={() => {
                    setMultipleRejectOrderConfirmModal(
                      !multipleRejectOrderConfirmModal,
                    );
                  }}
                />
              )}

              {partiallyAcceptOrderConfirmModal && (
                <PartiallyAcceptOrderConfirmModal
                  isOpen={partiallyAcceptOrderConfirmModal}
                  accept={partiallyAccept}
                  toggle={() => {
                    setPartiallyAcceptOrderConfirmModal(
                      !partiallyAcceptOrderConfirmModal,
                    );
                    setPartiallyAcceptOrderConfirmProductId('');
                  }}
                />
              )}
              {rejectOrderConfirmModal && (
                <RejectOrderConfirmModal
                  isOpen={rejectOrderConfirmModal}
                  rejectOrder={rejectOrder}
                  toggle={() => {
                    setRejectOrderConfirmModal(!rejectOrderConfirmModal);
                    setRejectOrderConfirmProductId('');
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OpenOrders;
